

import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App'
import tool from './libs/elextend'
import {setToken,getCookie,setCookie} from './libs/util'
import "../static/icon/iconfont.css"
import "../static/theme/normal/common/common.less"

import VConsole from 'vconsole'


import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'


/* 提示框 */
Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)

Vue.config.productionTip = false


window.vgetCookie = getCookie;
window.vsetCookie = setCookie;

Vue.mixin({
created() {

var load = vgetCookie('themeLoad',function(s){
return 'true'===s
});
if(!load) {
vsetCookie("themeLoad",true, new Date(new Date().getTime() + 1000 * 60));
this._updateTheme();
}
},
methods:{
handleResponse: function(res) {
this.$vux.loading.hide();
if (res.data) {
if(res.data.data && res.data.data === "no login"){

setToken();
this.$router.push({
path: "/"
});
}else{
if(res.data.code != 0) {
this.$vux.toast.text(res.data.message || res.data.msg);
}
return res.data;
}
} else if( res.response && res.response.data && res.response.data.message){
this.$vux.toast.text(res.response.data.message);
return null;
} else if (res.response && res.response.status) {
this.$vux.toast.text(res.response.statusText);
return null;
} else if( res.timeout) {
this.$vux.toast.text("网络链接超时,请稍后再试！");
return null;
}
},
_updateTheme() {

setTimeout(function(){
vsetCookie("theme","normal");
},100);
/* $.ajax({
url: types.GETTEMP,
async: false,
data: {
StoreId: StoreId
},
success: function(da) {
self.templatesMu(da)
}
}); */
},
_getLess(filepath, filename) {
return require("./../static/theme/" + (vgetCookie("theme") || 'normal') + "/" + filepath + "/" + filename + "/index.less");
},
_getImage(filename) {
var filePath = require("./../static/theme/" + (vgetCookie("theme") || 'normal') + "/img/" + filename);
return filePath;
},
}
});


const FastClick = require('fastclick')
FastClick.attach(document.body)

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js